import React from 'react';
import { LuLayoutDashboard } from 'react-icons/lu';
import { lazyPage } from '../lazyPage';

const HomePage = lazyPage(() => import(/* webpackChunkName: "m-home" */ './pages/HomePage'));

/**
 * Home manifest. `home_mgmt` does not exist in the permission store, so — like
 * the insights_mgmt pattern — scoped users are unaffected while null-permission
 * admins see the nav entry. The PAGE itself is reachable by everyone regardless
 * (routes are never permission-gated in this app); it is the landing target for
 * every signed-in user, and it composes itself from grants.
 */
const homeManifest = {
    id: 'home',
    featureName: 'home_mgmt',
    permission: 'view',
    routes: [{ path: '/home', element: <HomePage /> }],
    // alwaysVisible: every signed-in user lands here, so it must stay reachable
    // from the nav even for a role with no grants at all.
    sidebarItems: [{ text: 'Home', icon: <LuLayoutDashboard />, link: '/home', alwaysVisible: true }],
};

export default homeManifest;
